import type { ReactNode } from 'react';

import { ImprintFooter } from './imprint-footer.js';
import { TenantHeader } from './tenant-header.js';

interface AppShellProps {
  readonly children: ReactNode;
}

/**
 * Page-Wrapper im Lovable-Layout: sanfter Hintergrundverlauf aus
 * `--background` zu `--brand-soft`, zentrale `max-w-md`-Spalte, oben der
 * `TenantHeader` (Logo + Praxisname + DE/EN-Pill), darunter der animierte
 * Screen-Bereich.
 *
 * Wird genau einmal von `<App>` (und der `<MockApp>`-Variante) gerendert;
 * die Screens selbst wickeln ihren Inhalt in `<ScreenShell>` und rendern
 * keine AppShell mehr.
 *
 * Die PhoneLink-CTAs leben bewusst im Screen-Inhalt selbst, damit sie mit der
 * Screen-Animation kommen und gehen. Der einzige statische Bottom-Inhalt ist
 * der `ImprintFooter` (dezenter Impressum-Link), der unter dem Screen-Bereich
 * steht und so auf allen Screens sichtbar bleibt.
 */
export function AppShell(props: AppShellProps): JSX.Element {
  return (
    <div className="relative min-h-dvh bg-gradient-to-b from-background to-brand-soft text-foreground">
      <div className="mx-auto flex min-h-dvh max-w-md flex-col">
        <TenantHeader />
        <main className="flex flex-1 flex-col">{props.children}</main>
        <ImprintFooter />
      </div>
    </div>
  );
}
